import $ from 'jquery';
import Swiper from 'swiper';
import Navigation from 'swiper/modules/navigation.mjs';
import Pagination from 'swiper/modules/pagination.min.mjs';
import Autoplay from 'swiper/modules/autoplay.min.mjs';
// import EffectFade from 'swiper/modules/effect-fade.mjs';

 
const slider = new Swiper('.slider', {
    modules: [Autoplay],
    speed: 1200,
    spaceBetween: 15,
    loop: false,
    slidesPerView: 1,
    autoplay: {
        delay: 80000,
        disableOnInteraction: true, 
    },
  });
const opinie__sl = new Swiper('.opinie__sl', {
    modules: [Autoplay,Pagination],
    speed: 1200,
    spaceBetween: 15,
    loop: true,
    slidesPerView: 1,
    autoplay: {
        delay: 80300,
        disableOnInteraction: true, 
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true, 
    },
    breakpoints: {
        '500': {
          slidesPerView: 1,
        },
        '720': {
          slidesPerView: 1.6,
        },
        '1050': {
          slidesPerView: 2.5,
        },
        '1450': {
          slidesPerView: 3,
        },
      }
  });
const cs__sl = new Swiper('.cs__sl', {
    modules: [Autoplay,Pagination],
    speed: 1200,
    spaceBetween: 15,
    loop: true,
    slidesPerView: 1.1,
    autoplay: {
        delay: 80300,
        disableOnInteraction: true, 
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true, 
    },
    breakpoints: {
        '500': {
          slidesPerView: 1.2,
        },
        '720': {
          slidesPerView: 1.6,
        },
        '1450': {
          slidesPerView: 2,
        },
      }
  });

  // const review__box = new Swiper('.review__box', {
  //   modules: [Autoplay,Pagination],
  //   speed: 800,
  //   spaceBetween: 15,
  //   loop: false,
  //   slidesPerView: 1,
  //   autoplay: {
  //       delay: 8000,
  //       disableOnInteraction: true,
  //   },
  //   pagination: {
  //     el: '.swiper-pagination__review',
  //     clickable: true, 
  //   },
  // });
  
  const proces__sl = new Swiper(".proces__sl", {
    modules: [Autoplay],
    loop: false,
    speed: 600,
    slidesPerView:1.1,
    spaceBetween: 10,
    autoplay: {
        delay: 5500,
        disableOnInteraction: false,
    },
    breakpoints: {
        '500': {
          slidesPerView: 1.5,
        },
        '720': {
          slidesPerView: 2.2,
        },
        '1050': {
          slidesPerView: 3.5,
        },
        '1450': {
          slidesPerView: 4.5,
        },
      }
});




